import { BeatLoader } from "react-spinners";

export default function Loader() {
  return (
    <div className="mt-8 flex justify-center w-full">
      <BeatLoader color="#8358FF" />
    </div>
  );
}
